import { useMemo } from 'react';
import useConfig from './useConfig';

const imageSrcBuilder = (host = 'images.gasbuddy.io') => (image) => {
  const { height, url, width } = image || {};

  if (url) {
    return `https://${host}/${width || 'auto'}x${height || 'auto'}/${url}`;
  }
  return undefined;
};

export default function useImageSrcBuilder() {
  const { imagesHost } = useConfig();
  return useMemo(() => imageSrcBuilder(imagesHost), [imagesHost]);
}
